import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import PropTypes from 'prop-types';
import ActionLink from "../../../controls/ActionLink";
import PdfViewerModal from "../../../modals/PdfViewerModal";

class ProductsModal extends Component {
    static propTypes = {
        products: PropTypes.array.isRequired,
        show: PropTypes.bool.isRequired,
        onHide: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        showSpecificationModal: false,
        specificationId: 0
    };

    render() {
        const {products, ...props} = this.props;
        return (
            <Modal {...props} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Типы паллет</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Для площадки доступны следующие типы (кликните, чтобы открыть спецификацию):</p>
                    {products.map(product =>
                        <div key={product.id}>
                            {
                                product.specDocumentId
                                    ? (
                                        <ActionLink onClick={() => this.showSpecification(product)}>
                                            {product.text}
                                        </ActionLink>
                                    )
                                    : product.text
                            }
                        </div>
                    )}
                    <PdfViewerModal documentId={this.state.specificationId}
                                    show={this.state.showSpecificationModal}
                                    onHide={() => this.setState({showSpecificationModal: false})}/>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-default"
                            onClick={props.onHide}>
                        Закрыть
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }

    showSpecification({specDocumentId}) {
        this.setState({
            showSpecificationModal: true,
            specificationId: specDocumentId
        });
    }
}

export default ProductsModal;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/modals/ProductsModal.js